 
import Button from '@/components/Button'
import { Input } from '@/components/ui/input'  
import { 
    FormControl, 
    FormItem,
    FormLabel,
    FormMessage
} from '@/components/ui/form' 
import { useState } from 'react' 
import { useToast } from '@/components/ui/use-toast' 
import { ResearchedProduct } from '@/types/MarketResearch'
import { Eye, Trash } from 'lucide-react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteImageResearchedProduct, uploadImageResearchedProduct } from '@/api/business/marketResearch'
import { ResearchedProductKeys } from '@/queries/useResearchedProductQuery'

interface ImageProductMarketResearchProps { 
    itemEdit: ResearchedProduct 
    handleViewImage: (key: string) => void
}

const ImageProductMarketResearch = ({ itemEdit, handleViewImage }: ImageProductMarketResearchProps) => {  
    const queryClient = useQueryClient() 
    const [displayConfirmDelete, setDisplayConfirmDelete] = useState('hidden')
    const [file, setFile] = useState<FileList>()
    const [displayBtnUpload, setDisplayBtnUpload] = useState('hidden')
     
    const { toast } = useToast()  
 
    const handleDeleteItem = () => {
        setDisplayConfirmDelete('grid')
    }

    const handleResponseDeleteItem = (res: boolean) => {
        if(res) {
           mutate({
                SK_PRODUTOS_PESQUISADOS: itemEdit.SK_PRODUTOS_PESQUISADOS
            })
            return
        }

        setDisplayConfirmDelete('hidden')
    }
 
    const { mutate, isPending } = useMutation({
        mutationFn: deleteImageResearchedProduct,
        onSuccess: () => {  
            queryClient.invalidateQueries({ queryKey: ResearchedProductKeys.details() })
            itemEdit.DS_CHAVE_ARQUIVO = ''
            toast({
                title: 'Excluir imagem com sucesso na pesquisa'
            })
             setDisplayConfirmDelete('hidden')
        },
        onError: () => {
            let errorMessage =
                'Não foi possível adicionar o produto. Tente novamente mais tarde.'

            toast({
                title: 'Erro ao adicionar o produto',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    const handleUploadImage = () => {
        if(file && file?.length > 0) {
            mutateUpload({
                IMAGEM: file?.[0],
                SK_PRODUTOS_PESQUISADOS: itemEdit.SK_PRODUTOS_PESQUISADOS
            })
        }
    }

    const { mutate: mutateUpload, isPending: isPendingUpload } = useMutation({
        mutationFn: uploadImageResearchedProduct,
        onSuccess: (res) => {   
            queryClient.invalidateQueries({ queryKey: ResearchedProductKeys.details() })
            itemEdit.DS_CHAVE_ARQUIVO = res.DS_CHAVE_ARQUIVO
            itemEdit.DD_NOME_ARQUIVO = res.DD_NOME_ARQUIVO
            toast({
                title: 'Upload efetuado com sucesso na pesquisa'
            })
             setDisplayConfirmDelete('hidden')
        },
        onError: () => {
            let errorMessage = 'Não foi possível efetuar o upload. Tente novamente mais tarde.'

            toast({
                title: 'Erro ao efetuar o upload',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    return (  
        <div>
            {itemEdit.DS_CHAVE_ARQUIVO && (
                <>
                    <div className="flex gap-1.5 mt-2">
                        <Eye className='text-blue-600 mt-0.5' size={14} />
                        <a onClick={() => handleViewImage(itemEdit.DS_CHAVE_ARQUIVO)} className="text-xs text-blue-600 font-semibold cursor-pointer">
                            Visualizar imagem
                            <p>{itemEdit.DD_NOME_ARQUIVO}</p>
                        </a>

                        <a onClick={() => handleDeleteItem()} className='fixed right-8'>
                            <Trash size={18} className='text-red-500 cursor-pointer'/>  
                        </a> 
                    </div> 

                    <div className={`gap-2 mt-2  mb-3 ${displayConfirmDelete}`}>
                        <span>
                            Realmente deseja excluir esta imagem?
                        </span>
                        <div className='gap-6 grid grid-flow-col'>
                            <Button
                                type="button" 
                                variant="outline"
                                onClick={() => handleResponseDeleteItem(false)}
                            >
                                Não
                            </Button>
                            <Button  
                                type="button"
                                isLoading={isPending}
                                onClick={() => handleResponseDeleteItem(true)}
                            >
                                Sim
                            </Button>

                        </div>
                    </div>
                </>
            )}
            {!itemEdit.DS_CHAVE_ARQUIVO && ( 
                <>
                    <FormItem>
                        <FormLabel>Imagem do preço do produto</FormLabel>

                        <div className='gap-6 grid grid-flow-col mt-2'> 
                            <FormControl>
                                <Input
                                type="file"
                                accept="image/*"
                                capture="environment"
                                onChange={(e) => {
                                    const files = e.target.files
                                    files && setFile(files) 
                                    console.log('files',files)
                                    if(files && files?.length > 0) {
                                        setDisplayBtnUpload('block')
                                    } else {
                                        setDisplayBtnUpload('hidden')
                                    }
                                }}
                                />
                                
                            </FormControl> 
                            <Button isLoading={isPendingUpload} type="submit" className={`${displayBtnUpload}`} onClick={() => handleUploadImage()}>
                                Upload
                            </Button>
                        </div>     
                       
                        <FormMessage />
                    </FormItem>
                    
                   
                </>
            )}

                
               
        </div>
    )
}

export default ImageProductMarketResearch
